import {CsvMetadataRestDto, PrepareCsvHandlingRequestRestDto} from "@/api/pharma-cpc-import/models";
import {CsvMetadataRestDtoModel} from "@/models/api/pharma-cpc-import/CsvMetadataRestDtoModel";

export class PrepareCsvHandlingRequestRestDtoModel implements PrepareCsvHandlingRequestRestDto {
    document_key: string;
    csv_metadata: CsvMetadataRestDto;

    constructor(document_key: string, csv_metadata: CsvMetadataRestDto) {
        this.document_key = document_key;
        this.csv_metadata = csv_metadata;
    }

    static createWithDefaults(): PrepareCsvHandlingRequestRestDtoModel {
        return new this('',CsvMetadataRestDtoModel.createWithDefaults());
    }
}
